module.exports = __webpack_public_path__ + "img/card5.4b258a0a.svg";